// extracted by mini-css-extract-plugin
export default {"providerIcon":"P_IgaLOeyoddx6aN4fjS"};